const url = 'https://erp.jms.co.ug/api/fundraising/';
// const url = 'http://localhost:8000/fundraising/';


export default { url };